export const squareKilometersToAcres = (x: number) => x * 247.105
export const acresToSquareKilometers = (x: number) => x / 247.105
export const metricTonsCO2ToCars = (x: number) => x / 4.64
export const metricTonsCO2ToUSHomes = (x: number) => x / 7.94
export const poundsPM25ToCars = (x: number) => x / 2.17
export const squareKilometersToSquareMeters = (x: number) => x * 1000000
export const squareMetersToSquareKilometers = (x: number) => x / 1000000
